<template>
    <div name="short-url">
        <loading 
            v-show="isLoading"
        />
    </div>
</template>

<script>
import Loading from '@/components/molecules/Loading';
import Constant from '@/constant';

export default {
    components: { Loading },
    name: 'shortUrl',
    data: function()
    {
        return {
            key: null,
            isLoading: false
        }
    },
    mounted: function()
    {
        this.key = this.$route.query.key;
        if(this.key === null || this.key === undefined || this.key === '')
        {

        }
        else
        {
            this.$store.dispatch(Constant.FETCH_SHORT_URL, {key: this.key})
                .then((res) => {
                    window.location.href = res;    
                })
                .catch((err) => {

                })
        }
       
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/page/shorturl/index.vue